// extracted by mini-css-extract-plugin
export default {"container":"ApprovePointCampaignList_container__7tWsT"};